export default __webpack_public_path__ + "static/media/banner_425x500_DM_grande.928c83bb.png";